/**
 * A `data:` URL as a Blob (KPR-1668).
 *
 * A canvas and a chart draw a data URL; `platform.saveFile` takes bytes, so
 * every file keepr saves, prints or shares reaches the platform as a Blob
 * whatever drew it. Synchronous on purpose: the callers are inside a click
 * handler and the web's save runs in the same turn.
 *
 * Throws a TypeError for anything that is not a data URL, so a caller never
 * saves an empty file by mistake.
 */
export function dataUrlToBlob(dataUrl) {
	const match = /^data:([^,;]*)((?:;[^,;]*)*),([\s\S]*)$/.exec(typeof dataUrl === 'string' ? dataUrl : '');
	if (!match) throw new TypeError('Not a data URL');
	const [, type, params, payload] = match;
	const base64 = /;base64$/i.test(params);
	const binary = base64 ? atob(payload) : decodeURIComponent(payload);
	const bytes = new Uint8Array(binary.length);
	for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
	return new Blob([bytes], { type: type || 'text/plain' });
}
